import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { IconButton } from '@material-ui/core'
import ForwardIcon from '@material-ui/icons/ArrowForward'
import BackIcon from '@material-ui/icons/ArrowBack'
import { cloneDeep } from 'lodash'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    sharingTableWrapper: {
        flex: 5
    },
    sharingButtonsWrapper: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    moveToIcon: {
        color: theme.textPrimary
    }
}))

export default function SharingTables(props) {
    const classes = useStyles()

    const {
        leftData,
        rightData,
        selectedLeftData,
        selectedRightData,
        uniqueKey,
        setLeftData,
        setRightData,
        leftTable,
        rightTable
    } = props

    const onMoveToRight = () => {
        const newData = leftData.reduce((acc, item) => {
            if (!selectedLeftData.hasOwnProperty(item[uniqueKey])) {
                acc.newLeftData.push(item)
            } else {
                acc.newRightData.push(item)
            }
            return acc
        }, {
            newLeftData: [],
            newRightData: [...cloneDeep(rightData)]
        })
        setLeftData(newData.newLeftData)
        setRightData(newData.newRightData)
    }

    const onMoveToLeft = () => {
        const newData = rightData.reduce((acc, item) => {
            if (!selectedRightData.hasOwnProperty(item[uniqueKey])) {
                acc.newRightData.push(item)
            } else {
                acc.newLeftData.push(item)
            }
            return acc
        }, {
            newLeftData: [...cloneDeep(leftData)],
            newRightData: []
        })
        setLeftData(newData.newLeftData)
        setRightData(newData.newRightData)
    }

    return (
        <div className={classes.root}>
            <div className={classes.sharingTableWrapper}>
                {leftTable}
            </div>
            <div className={classes.sharingButtonsWrapper}>
                <IconButton
                    size='small'
                    className={classes.moveToIcon}
                    onClick={onMoveToRight}
                    disabled={Object.keys(selectedLeftData).length === 0}
                >
                    <ForwardIcon />
                </IconButton>
                <IconButton
                    size='small'
                    className={classes.moveToIcon}
                    onClick={onMoveToLeft}
                    disabled={Object.keys(selectedRightData).length === 0}
                >
                    <BackIcon />
                </IconButton>
            </div>
            <div className={classes.sharingTableWrapper}>
                {rightTable}
            </div>
        </div>
    )
}
